import { useEffect, useState } from "react";
import DateInput from "components/elements/DateInput";
import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import Table from "components/elements/Table";
import IconButton from "components/elements/IconButton";
import dataProvider from "core/DataProvider";
import toast from "react-hot-toast";
import utility from "core/Utils";

const headerMap = {
  title: "Title",
  description: "Description",
  period_from: "Period from",
  period_to: "Period to",
  action: "Actions",
};

const NotificationListing = props => {
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [notificationList, setNotificationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [formCollapsed, setFormCollapsed] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let data = await dataProvider.network.get("notification");
      data = data.map(x => ({
        ...x,
        period_from: utility.formatDate(x.period_from),
        period_to: utility.formatDate(x.period_to),
        action: (
          <div className="action flex flex-v-center">
            <div
              className="action-button flex flex-center"
              onClick={() => {
                props.edit(x);
              }}
            >
              <EditIcon />
            </div>
          </div>
        ),
      }));
      setNotificationList(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="notification-listing">
      <div className="flex">
        <div className="flex right flex-v-center">
          {loading ? (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          ) : (
            <IconButton
              icon="add"
              text="Add Notification"
              onClick={() => props.submit()}
            />
          )}
        </div>
      </div>
      <div className="flex mtop">
        <div
          className={formCollapsed ? "form-wrapper collapsed" : "form-wrapper"}
          style={{ display: "none" }}
        >
          <div className={"form-segment"}>
            <div className="segment-body">
              <DateInput
                value={periodFrom}
                onChange={val => setPeriodFrom(val)}
                placeholder="Period from"
              />
              <DateInput
                value={periodTo}
                onChange={val => setPeriodTo(val)}
                placeholder="Period to"
              />
            </div>
          </div>
          <button onClick={fetchData}>Submit</button>
          <div
            className="collapser"
            onClick={e => setFormCollapsed(!formCollapsed)}
          >
            <ArrowIcon />
          </div>
        </div>
        <div
          className="results-wrapper"
          style={{ width: "100%", marginLeft: "0" }}
        >
          <div className="head flex flex-v-center">
            <h3>Notifications</h3>
            <div className="right">
              <div className="flex flex-v-center">
                <div className="el">
                  <input
                    type="text"
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="results">
            <Table
              headers={headerMap}
              data={notificationList}
              search={search}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationListing;
